import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationService } from 'src/@core/services/notification.service';
import { API_BOOKING, API_FETCH_BOOKINGS } from 'src/@core/services/util/api.endpoints';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';
import { RequestQuoteComponent } from '../../request-quote/request-quote.component';
import { MatDialog, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { AppService } from 'src/@core/services/app.service';
declare var Razorpay: any;

@Component({
  selector: 'hour4u-admin-bookings-list',
  templateUrl: './bookings-list.component.html',
  styleUrls: ['./bookings-list.component.scss']
})
export class BookingsListComponent implements OnInit {
  bookings: any[] = [];
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  pageSizeOptions: number[] = [10, 20, 50, 100, 500];
  @Input() bookingStatus?: any;
  @Input() profile?: any;
  roles = roles;
  entityTypes = entityTypes;
  isLoading: boolean = false;
  diameter = 30;
  color: string;
  mode = 'indeterminate';
  currentUserRole: any = null;

  constructor(
    private http: HttpClient,
    private notify: NotificationService,
    public dialog: MatDialog,
    private router: Router,
    private appService: AppService
  ) { }

  ngOnInit() {
    this.getCurrentRole();
  }

  // get current user role
  getCurrentRole() {
    this.appService.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.currentUserRole = ele;
          console.log(this.currentUserRole)
          this.fetchBookings();
        })
      }
    })
  }

  fetchBookings(): void {
    this.isLoading = true;
    console.log(this.profile)
    const createdBy = this.profile.user.id;
    const sort = 'createdOn,desc';
    this.bookings = [];
    let httpParams = new HttpParams()
      .set('sort', sort)
      .set('page', this.pageIndex.toString())
      .set('size', this.pageSize.toString())
      .set('bookingStatus', this.bookingStatus);

    // if (this.currentUserRole === 'ENTERPRISE_ADMIN' || this.currentUserRole === 'ENTERPRISE_STAFF') {
    //   httpParams = httpParams.set('enquiredByEntityId', createdBy);
    // }

    this.http.get<any>(API_FETCH_BOOKINGS, { params: httpParams }).subscribe(
      (response) => {
        this.isLoading = false;
        if (response && Array.isArray(response.content)) {
          this.bookings = response.content;
          this.bookings.forEach(ele => {
            if (ele.enquiry.services && ele.enquiry.services.length) {
              ele.services = ele.enquiry.services.join(',');
            }
          })
        }
        this.resultsLength = response.totalElements;
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch bookings:', error);
      }
    );
  }

  // change Application Status
  changeApplicationStatus(status, data) {
    this.http.get(API_BOOKING + '/' + data.id + '/' + status).subscribe(
      (response: any) => {
        if (status == 'APPROVED') {
          this.notify.showMessage("Quotation approved Successfully!", 2000);
          this.payQuote(response);
        } else {
          this.notify.showMessage("Quotation rejected Successfully!", 2000);
          this.fetchBookings();
        }
      }, (err => {
      }))
  }

  payQuote(booking) {
    console.log(booking)
    const razorPayOptions = {
      amount: booking.quotation.totalAmount * 100, // Multiplying by 100 to convert to paisa
      currency: 'INR',
      key: environment.rezorpayKey,
      order_id: booking.paymentDetails.razorPayOrderId,
      invoice_id: booking.paymentDetails.razorPayInvoiceId,
      "handler": (paymentResponse: any) => {
        console.log("$$$$$$$$$$44", paymentResponse)
        this.fetchBookings();
        this.notify.showMessage("Payment success and Booking saved. Redirecting to my bookings", 2000);
        // Perform any necessary action upon successful payment here

      },
      "modal": {
        "ondismiss": () => {
          console.log('Payment window dismissed');
          // Handle dismiss scenarios if required
        }
      }
    };

    // Initiate Razorpay payment with the provided options
    const rzp = new Razorpay(razorPayOptions);
    rzp.open();

    rzp.on('payment.failed', function (response: any) {
      // Handle payment failure if required
      console.error('Payment failed:', response);
    });
  }

  // send Quote
  sendQuote(data) {
    console.log(data)
    const dialogRef = this.dialog.open(RequestQuoteComponent, {
      width: '488px',
      panelClass: 'add-edit-user-dialog',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.fetchBookings();
      }
    });
  }

  onPageChange(event: PageEvent): void {
    console.log(event)
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchBookings();
  }

  viewBooking(data) {
    console.log(data)
    this.router.navigateByUrl(`/bookings/view-booking/${data.id}`)
  }

  displayBookingState() {
    if (this.bookingStatus) {
      if (this.bookingStatus == "ENQUIRY_POSTED") {
        return "No booking is in pending state!";
      }
      if (this.bookingStatus == "QUOTATION_SENT") {
        return "No booking is in quote state!";
      }
      if (this.bookingStatus == "APPROVED") {
        return "No booking is in approved state!";
      }
      if (this.bookingStatus == "REJECTED") {
        return "No booking is in rejected state!";
      }
    } else {
      return "No booking found!";
    }
  }
}
